// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3MLk1","actions":"GroupTable_actions__21NEP","deleteModalFooter":"GroupTable_deleteModalFooter__TBno0"};